export default __webpack_public_path__ + "static/media/scholarship-header.225633ba.png";